import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPupDrsl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_DRSL: Record<
  Exclude<PageIdWoofzPupDrsl, PageIdWoofzPupDrsl.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzPupDrsl.DOG_AGE_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.DOG_AGE_PUP_DRSL,
    hasHeader: true,
  },
  [PageIdWoofzPupDrsl.DOG_OWNER_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.DOG_OWNER_PUP_DRSL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.TRAINING_COMMANDS_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.TRAINING_COMMANDS_PUP_DRSL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.URGE_PAGE_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.URGE_PAGE_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPupDrsl.DOG_BREED_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.DOG_BREED_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.FACING_CHALLENGES_PUP_DRSL]: {
    id: PageId.FACING_CHALLENGES_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.FACING_CHALLENGES_2_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.FACING_CHALLENGES_2_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.BEHAVIOR_FREQUENCY_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.BEHAVIOR_FREQUENCY_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.URGE_PROGRAM_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.URGE_PROGRAM_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.BEHAVIOR_FEELINGS_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.BEHAVIOR_FEELINGS_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.FIX_BEHAVIOR_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.FIX_BEHAVIOR_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.URGE_PAGE_4_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.URGE_PAGE_4_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.COMMANDS_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.COMMANDS_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.PARENT_GOAL_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.PARENT_GOAL_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.TRAINING_PLACE_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.TRAINING_PLACE_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.TRAINING_FREQUENCY_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.TRAINING_FREQUENCY_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupDrsl.URGE_PAGE_5_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.URGE_PAGE_5_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPupDrsl.PREPARE_FLOW_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.PREPARE_FLOW_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.EMAIL_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.EMAIL_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.NEWSLETTER_URGE_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.NEWSLETTER_URGE_PUP_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupDrsl.LAST_CHANCE_OFFER_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.LAST_CHANCE_OFFER_PUP_DRSL,
  },
  [PageIdWoofzPupDrsl.SUBSCRIPTIONS_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.SUBSCRIPTIONS_PUP_DRSL,
  },
  [PageIdWoofzPupDrsl.CHAT_UPSELL_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.CHAT_UPSELL_PUP_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupDrsl.UPSELL_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.UPSELL_PUP_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupDrsl.UPSELL_FEEDING_GUIDE_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.UPSELL_FEEDING_GUIDE_PUP_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupDrsl.UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupDrsl.DOWNLOAD_PUP_DRSL]: {
    id: PageIdWoofzPupDrsl.DOWNLOAD_PUP_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
